// document.addEventListener("DOMContentLoaded", function () {
// 	const sliders = document.querySelectorAll(".swiper-hebergement");
// 	const cards = document.querySelectorAll(".card-gamme");

// 	cards.forEach((card) => {
// 		const items = card.querySelectorAll(".booking_last_item");

// 		items.forEach((item) => {
// 			item.addEventListener("click", function () {
// 				items.forEach((el) => el.classList.remove("selected"));

// 				item.classList.add("selected");
// 			});
// 		});
// 	});


// 	sliders.forEach((slider) => {
// 		let swiperInstance = null;

// 		function initSwiper() {
// 			const isMobile = window.innerWidth <= 768;

// 			if (isMobile && !swiperInstance) {
// 				swiperInstance = new Swiper(slider, {
// 					slidesPerView: 1,
// 					spaceBetween: 30,
// 					pagination: {
// 						el: slider.querySelector(".swiper-pagination"),
// 						clickable: true,
// 						dynamicBullets: true
// 					},
// 					navigation: {
// 						nextEl: slider.querySelector(".swiper-button-next"),
// 						prevEl: slider.querySelector(".swiper-button-prev"),
// 					},
// 					simulateTouch: true,
// 					lazy: {
// 						enabled: true
// 					},
// 					watchSlidesProgress: true,
// 					observer: true,
// 					observeParents: true,
// 					resizeObserver: true
// 				});
// 			}

// 			if (!isMobile && swiperInstance) {
// 				swiperInstance.destroy(true, true);
// 				swiperInstance = null;
// 			}
// 		}

// 		initSwiper();
// 		window.addEventListener("resize", initSwiper);
// 	});
// });
